import { ref, watch, onScopeDispose } from "vue";

export function useTypewriter(textRef, options = {}) {
  const speed = options.speed ?? 18;
  const initialDelay = options.delay ?? 200;
  const enabledRef = options.enabled;

  const typedText = ref("");
  const isTyping = ref(false);
  const done = ref(false);

  let timer = null;
  let startTimer = null;

  function clearAll() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (startTimer) {
      clearTimeout(startTimer);
      startTimer = null;
    }
  }

  function startTyping() {
    clearAll();
    const full = textRef.value || "";
    typedText.value = "";
    done.value = false;

    if (!full) {
      isTyping.value = false;
      done.value = true;
      return;
    }

    isTyping.value = true;

    let i = 0;
    const tick = () => {
      i += 1;
      typedText.value = full.slice(0, i);
      if (i < full.length) {
        timer = setTimeout(tick, speed);
      } else {
        isTyping.value = false;
        done.value = true;
      }
    };
    startTimer = setTimeout(tick, initialDelay);
  }

  function reset() {
    clearAll();
    typedText.value = "";
    isTyping.value = false;
    done.value = false;
  }

  function isEnabled() {
    if (!enabledRef) return true;
    if (typeof enabledRef === "function") return Boolean(enabledRef());
    return Boolean(enabledRef.value);
  }

  watch(
    () => [textRef.value, isEnabled()],
    ([text, enabled]) => {
      if (enabled && text) {
        startTyping();
      } else {
        reset();
      }
    },
    { immediate: true }
  );

  onScopeDispose(clearAll);

  return { typedText, isTyping, done, restart: startTyping, reset };
}
